import Model from './model.js';

export default class SocialMedia extends Model
{
    constructor(social){
        super()
        this.id             = 0
        
        this.published      = false
        this.url            = ''
        this.type_name      = ''
        
        this.map(social)
        this.init()
    }

    map(social){
        if(social == undefined) return
        this.id             = social.id
        this.published      = social.published
        this.url            = social.url
        this.type_name      = social.type.name
    }

    toJson(){
       return {
           published: this.published,
           url: this.url
       }
    }
}

